/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuPriceRanges_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly " $refType": "SbSharedRefineMenuPriceRanges_user";
};
export type SbSharedRefineMenuPriceRanges_user$data = SbSharedRefineMenuPriceRanges_user;
export type SbSharedRefineMenuPriceRanges_user$key = {
    readonly " $data"?: SbSharedRefineMenuPriceRanges_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuPriceRanges_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuPriceRanges_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVerifiedTrade",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '5f28254e4fdc4994adaee2f3f6380047';
export default node;
